var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Input } from "antd";
import { omit } from 'lodash';
import { formatter, parser } from './utils';
export var InputMoneySeparatorType;
(function (InputMoneySeparatorType) {
    InputMoneySeparatorType["dot"] = ".";
    InputMoneySeparatorType["comma"] = ",";
})(InputMoneySeparatorType || (InputMoneySeparatorType = {}));
export var InputMoneySeparator = {
    dot: InputMoneySeparatorType.dot,
    comma: InputMoneySeparatorType.comma
};
var InputMoney = /** @class */ (function (_super) {
    __extends(InputMoney, _super);
    function InputMoney() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: "",
            validValue: ""
        };
        _this.formatter = function (value) {
            return formatter(value, _this.props.decimalSeparator, _this.props.thousandSeparator, _this.props.precision);
        };
        _this.parser = function (value) {
            return parser(value, _this.props.thousandSeparator);
        };
        _this.onChange = function (e) {
            var value = e.target.value;
            _this.setState({
                value: value,
                validValue: _this.parser(value)
            }, function () {
                if (typeof _this.props.onChange === 'function') {
                    _this.props.onChange(_this.state.validValue);
                }
            });
        };
        _this.render = function () {
            console.log('Input money');
            var value = _this.state.value;
            var formattedValue = _this.formatter(value);
            var inputProps = __assign(__assign({}, omit(_this.props, ['decimalSeparator', 'thousandSeparator'])), { value: formattedValue, onChange: _this.onChange });
            return (React.createElement(Input, __assign({}, inputProps)));
        };
        return _this;
    }
    InputMoney.getDerivedStateFromProps = function (props, state) {
        var s = __assign({}, state);
        if ('value' in props) {
            s.value = parser(props.value, props.thousandSeparator);
        }
        return s;
    };
    InputMoney.defaultProps = {
        decimalSeparator: InputMoneySeparatorType.comma,
        thousandSeparator: InputMoneySeparatorType.dot,
        precision: 2
    };
    return InputMoney;
}(React.Component));
export default InputMoney;
